export default "__VITE_ASSET__igvaCako__"